const verticalsKeys = {
  CARS: 'cars',
  AUTOMOTIVE: 'automotive',
};

export default verticalsKeys;
